<template>
  <div class="innerBox">

    <h2 class="mb-4">Daftar Work Order</h2>
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter</h4>
      </template>
      <div class="row outerBox filterBox" style="padding:0">
        <div class="col row">
          <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Cari</label>
            <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-on:keyup.enter="vue_universal_table.update++" v-model="filter.search">
          </div>
          <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Status Pekerjaan</label>
            <Multiselect
              :options="completeFilter.map(x => x.completed)"
              :custom-label="opt => completeFilter.find(x => x.completed == opt).name"
              v-model="filter.completed"
              placeholder="Pilih Status"
						/>
          </div>
          <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Tanggal</label>
            <flat-pickr
              v-model="selected.date"
              :config="rangeConfig"
              placeholder="Pilih Tanggal"
            ></flat-pickr>
          </div>
          <div class="col-md-3" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
            <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
          </div>
        </div>
      </div>
    </panel>

    
    <vue-universal-table
      :buttons="vue_universal_table.buttons"
      :dummy_table="false"
      :filter="filter"
      :fields="vue_universal_table.fields"
      :update="vue_universal_table.update"
      api_url="/api/v1/workorder/listing/ongoing-coloring"
      :disable_sort="true"
      :pagination="false"
      @onCreateWo="createNewWorkOrder"
      @onViewDetail="viewDetailWO"
    ></vue-universal-table>

    <WODetailColor
      v-if="modal.warna"
      :form_code="modal.warnaDetailFormCode"
      @closeModal="modal.warna = false"
    ></WODetailColor>

  </div>
</template>

<script>
  import moment from 'moment'
  import Multiselect from 'vue-multiselect'

  import WODetailColor from './children/WODetailColor'

  export default {
    data () {
      const start = moment().startOf('year').format('YYYY-MM-DD');
      let end  = new moment().format('YYYY-MM-DD')

      return {
        modal : {
          warna : false,
          warnaDetailFormCode : '',
        },
        data : null,
        filter: {
          start: start,
          end: end,
          search : '',
          completed : null
        },
        completeFilter : [{
          name : 'Belum Selesai',
          completed : 'false'
        }, {
          name : 'Selesai',
          completed : 'true'
        }],
        meta : null,
        data: null,
        mobile : this.isMobile(),
        selected : {
          date : `${start} to ${end}`,
        },
        rangeConfig: {
          mode: 'range',
          altInput: true,
          altInputClass: 'form-control input flatpickr-input w-100',
          animate: !this.isRTL()
        },
        showNewUserModal : false,
        apiLoading: true,
        vue_universal_table : {
          update: 0,
          process_data : `
            for (var i in data) { 
              data[i].log_name = data[i].log ? data[i].log.name : '-'
              data[i].step_name = data[i].step ? data[i].step.name : '-'
              data[i].conditionChecked = data[i].conditionChecked ? 'Y' : 'N'
            }
            
            data = data.filter(x=>x.step && x.step.name=='Warna')
          `,
          buttons : [
            {
              title : 'viewDetail',
              variable : 'form_code',
              class : 'btn-outline-primary fas fa-eye'
            }
          ],
          fields : [
            {
              title : 'Work Order ID',
              variable : 'form_code'
            },
            {
              title : 'No Polisi',
              variable : 'registration'
            },
            {
              title : 'Tipe Mobil',
              variable : 'car_name'
            },
            {
              title : 'Dibuat Pada',
              variable : 'created_at'
            },
            {
              title : 'CSO',
              variable : 'CSO'
            }
          ]
        }
      }
    },
    components : {
      WODetailColor,

      Multiselect
    },
    mounted () {

    },
    watch : {
      'selected.date'(){
        var date = this.selected.date.split(" to ");
        this.filter.start = date[0]
        this.filter.end = date[1] ? date[1] : date[0]
      },
    },
    methods : {
      createNewWorkOrder () {
        this.$router.push({name : 'WorkOrderFormNew'})
      },
      viewDetailWO (x) {
        this.$router.push({name : 'ColorDetail', params: {id : x.replace(/"/g, "")}})
        // this.modal.warnaDetailFormCode = x.replace(/"/g, '');
        // this.modal.warna = true;
      }
    }
  }
</script>

<style scoped>
  
</style>